import axios from "axios"

export const fetchAll = async() => {
    return await axios.get("https://api.themoviedb.org/3/trending/all/day?api_key=15e383204c1b8a09dbfaaa4c01ed7e17");
}

export const fetchMovie = async() => {
    return await axios.get("https://api.themoviedb.org/3/trending/movie/day?api_key=15e383204c1b8a09dbfaaa4c01ed7e17");
}

export const fetchShow = async() => {
    return await axios.get("https://api.themoviedb.org/3/trending/tv/day?api_key=15e383204c1b8a09dbfaaa4c01ed7e17");
}

export const searchQuery = async(query, page) => {
    console.log("Query ", query);
    return await axios.get(`https://api.themoviedb.org/3/search/movie?api_key=15e383204c1b8a09dbfaaa4c01ed7e17&language=en-US&query=${query}&page=${page}&include_adult=false`);
}
